import React from "react";
import { CANVAS_TOOL } from "../constants";
import { ThicknessBox, OpacityBox, ColorBox, EraserBox, FigureBox, ZoomBox } from "./CanvasToolOption";

const tool_option = [
    CANVAS_TOOL.thickness,
    CANVAS_TOOL.opacity,
    CANVAS_TOOL.color,
    CANVAS_TOOL.eraser,
    CANVAS_TOOL.figure,
    CANVAS_TOOL.zoom
];

export default function ToolOptionBox({ choiceTool }) {
    return (
        <>
            { tool_option.indexOf(choiceTool) !== -1 && 
                <div className={`option_box ${choiceTool} noClick`}>
                    { choiceTool === CANVAS_TOOL.thickness ? <ThicknessBox /> : null }
                    { choiceTool === CANVAS_TOOL.opacity ? <OpacityBox /> : null }
                    { choiceTool === CANVAS_TOOL.color ? <ColorBox /> : null }
                    { choiceTool === CANVAS_TOOL.eraser ? <EraserBox /> : null }
                    { choiceTool === CANVAS_TOOL.figure ? <FigureBox /> : null }
                    { choiceTool === CANVAS_TOOL.zoom ? <ZoomBox /> : null }
                </div>
            }
        </>       
    );
}